export const routes = ( prefix = `master-data` ) => [
    {
        path: `/${prefix}/templates-category`,
        name: `${prefix}.templates-category.index`,
        component: () => import('./category/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.templates-category.index`,
                PageDescription: "Template category listing/create",
            },
        },
    },
    {
        path: `/${prefix}/templates`,
        name: `${prefix}.templates.index`,
        component: () => import('./temps/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.templates.index`,
                PageDescription: "Template listing/create",
            },
        },
    },
];
